// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2afFO","buttons":"SendReceipts_buttons__IYiGf","email":"SendReceipts_email__1f2cE","bookApptTitle":"SendReceipts_bookApptTitle__e-bp2"};